import {
  Button,
  Classes,
  H5,
  InputGroup,
  Popover
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IMonofasicoSimples } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { Pager } from "../utils/Pager";
import {
  MDBBtn, MDBCol, MDBRow,
} from "mdbreact";
import * as moment from "moment";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { MonofasicoSimplesCreate } from "./MonofasicoSimplesCreate";
import { MonofasicoSimplesEdit } from "./MonofasicoSimplesEdit";
import { MonofasicoSimplesDuplicar } from "./MonofasicoSimplesDuplicar";
import { MonofasicoStore } from "../../stores/legislacao/MonofasicoStore";
var debounce = require('lodash.debounce');

interface Props {
}

interface State {
}

@observer
export class MonofasicoSimplesPage extends React.Component<Props, State> {

  obs = observable({
    adding: false as boolean,
    monofasico_edit: null as IMonofasicoSimples,
    monofasico_duplicar: null as IMonofasicoSimples,
    loading_export: false as boolean,
    fetchOptions: {} as any
  })

  constructor(props: Props) {
    super(props);

    this.obs.fetchOptions = debounce(this.handleFilter.bind(this), 800);

  }

  async componentDidMount() {
    AppStore.setTitle("Monofásico Simples Nacional");

    await MonofasicoStore.handleFilter(1, "");
  }

  handleAdd = () => {
    this.obs.adding = true;
  };

  handlePageChange = async (page: number) => {
    MonofasicoStore.obs.currentPage = page;

    await MonofasicoStore.handleFilter(page, "");

  };

  handleModalEdit = (aliquota: any) => {
    this.obs.monofasico_edit = aliquota

    if (this.obs.monofasico_edit.valido_de != null) {
      let newDate = new Date(this.obs.monofasico_edit.valido_de)
      newDate.setHours(newDate.getHours() + 24)
      this.obs.monofasico_edit.valido_de = newDate
    }

    if (this.obs.monofasico_edit.valido_ate != null) {
      let newDateAte = new Date(this.obs.monofasico_edit.valido_ate)
      newDateAte.setHours(newDateAte.getHours() - 3)
      this.obs.monofasico_edit.valido_ate = newDateAte
    }
  }

  handleModalDuplicar = (aliquota: any) => {
    this.obs.monofasico_duplicar = aliquota

    if (this.obs.monofasico_duplicar.valido_de != null) {
      let newDate = new Date(this.obs.monofasico_duplicar.valido_de)
      newDate.setHours(newDate.getHours() + 24)
      this.obs.monofasico_duplicar.valido_de = newDate
    }

    if (this.obs.monofasico_duplicar.valido_ate != null) {
      let newDateAte = new Date(this.obs.monofasico_duplicar.valido_ate)
      newDateAte.setHours(newDateAte.getHours() - 3)
      this.obs.monofasico_duplicar.valido_ate = newDateAte
    }
  }

  handleEditClose = () => {
    this.obs.monofasico_edit = null;
  };

  handleDuplicaClose = () => {
    this.obs.monofasico_duplicar = null;
  };

  validadeFormatter(d) {
    return d ? moment(d).add(3, "hour").format("DD/MM/YYYY") : null;
  }
  aliquotaFormatter(d) {
    return d ? d.toString().concat("%") : null
  }

  handleFilter() {

    MonofasicoStore.handleFilter(1, MonofasicoStore.obs.filter)

  }

  async handleExport() {
    this.obs.loading_export = true

    await MonofasicoStore.handleExport()

    this.obs.loading_export = false
  }

  render() {
    let items = MonofasicoStore.obs.monofasicos?.map((value) => {
      return (
        {
          id: value._id || value.id,
          ncm: value.ncm,
          item: value.item,
          descricao: value.descricao,
          legislacao: value.legislacao,
          valido_de: value.valido_de,
          valido_ate: value.valido_ate,
        }
      );
    });

    const buttonFormatterDetalhes = (cell, row) => {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={() => this.handleModalEdit(row)}
          >
            <img src="/images/edit.png" width={20} />
          </MDBBtn>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={(e) => this.handleModalDuplicar(row)}
          >
            <img src="/images/duplicate.svg" width={20} />
          </MDBBtn>
          <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
            <MDBBtn color="default" rounded size="sm">
              <img src="/images/bin.png" width={20} />
            </MDBBtn>
            <div>
              <H5>Confirmar exclusão?</H5>
              <p>Confirmar exclusão do ICMS Alíquota?</p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 15,
                }}
              >
                <Button
                  className={Classes.POPOVER_DISMISS}
                  style={{ marginRight: 10 }}
                >
                  Cancelar
                </Button>
                <Button
                  intent="danger"
                  className={Classes.POPOVER_DISMISS}
                  onClick={() => MonofasicoStore.handleDelete(row.id)}
                >
                  Excluir
                </Button>
              </div>
            </div>
          </Popover>
        </>
      )
    }

    let user_admin = AppStore.obs1.usuario ? AppStore.obs1.usuario.admin : false

    return (
      <>
        <div>

          <MDBRow style={{ marginBottom: 20 }}>
            <MDBCol md="12">

              {user_admin &&
                <MDBBtn className="btnDefault noFloat" onClick={this.handleAdd} style={{ marginRight: 10 }}>
                  Adicionar Monofásico
                </MDBBtn>
              }

              <Button
                icon="export"
                className="btnRoxo"
                onClick={() => this.handleExport()}
                loading={this.obs.loading_export}
              >
                Exportar
              </Button>

            </MDBCol>
          </MDBRow>

          <MDBRow>
            <MDBCol md="4">
              <InputGroup
                round
                style={{ width: "48%", float: "left", borderRadius: "10px" }}

                placeholder="Filtrar"
                value={MonofasicoStore.obs.filter}
                onChange={(e: any) => {
                  MonofasicoStore.obs.filter = e.target.value;
                  this.obs.fetchOptions()}}
              />
            </MDBCol>
          </MDBRow>

          <BootstrapTable className="TableDefault" ref="table" data={items}>
            <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
            <TableHeaderColumn dataField="item" width="10%">Item</TableHeaderColumn>
            <TableHeaderColumn dataField="ncm" width="10%">NCM</TableHeaderColumn>
            <TableHeaderColumn dataField="descricao" width="40%">Descrição</TableHeaderColumn>
            <TableHeaderColumn dataField="valido_de" dataFormat={this.validadeFormatter} width="15%">Valido de</TableHeaderColumn>
            <TableHeaderColumn dataField="valido_ate" dataFormat={this.validadeFormatter} width="15%"> Valido até </TableHeaderColumn>
            <TableHeaderColumn dataField="legislacao" width="10%">Legislação</TableHeaderColumn>
            {user_admin && <TableHeaderColumn dataFormat={buttonFormatterDetalhes} width="10%">Ações</TableHeaderColumn>}
          </BootstrapTable>

          <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
            <Pager
              currentPage={MonofasicoStore.obs.currentPage}
              totalCount={MonofasicoStore.obs.totalRows}
              pageSize={30}
              onPageChange={this.handlePageChange} />
          </div>
        </div>

        {this.obs.adding && <MonofasicoSimplesCreate onClose={() => this.obs.adding = false} />}
        {this.obs.monofasico_edit && <MonofasicoSimplesEdit monofasico={this.obs.monofasico_edit} onClose={this.handleEditClose} />}
        {this.obs.monofasico_duplicar && <MonofasicoSimplesDuplicar monofasico={this.obs.monofasico_duplicar} onClose={this.handleDuplicaClose} />}
      </>
    );
  }
}

export default MonofasicoSimplesPage;